import React, { createContext, useContext, useState, useEffect } from "react";

const PermissionsContext = createContext();

export const usePermissions = () => useContext(PermissionsContext);

export const PermissionsProvider = ({ children, initialRole }) => {
  const [permissions, setPermissions] = useState({
    isAdmin: false,
    isManager: false,
    isEditor: false,
    isReporter: false
  });

  useEffect(() => {
    const setPermissionsBasedOnRole = role => {
      switch (role) {
        case "admin":
          setPermissions({
            isAdmin: true,
            isManager: true,
            isEditor: true,
            isReporter: true
          });
          break;
        case "manager":
          setPermissions({
            isAdmin: false,
            isManager: true,
            isEditor: true,
            isReporter: true
          });
          break;
        case "editor":
          setPermissions({
            isAdmin: false,
            isManager: false,
            isEditor: true,
            isReporter: true
          });
          break;
        case "reporter":
          setPermissions({
            isAdmin: false,
            isManager: false,
            isEditor: false,
            isReporter: true
          });
          break;
        default:
          setPermissions({
            isAdmin: false,
            isManager: false,
            isEditor: false,
            isReporter: false
          });
      }
    };

    setPermissionsBasedOnRole(initialRole);
  }, [initialRole]);

  return <PermissionsContext.Provider value={{ permissions, setPermissions }}>{children}</PermissionsContext.Provider>;
};
